import Icon, { IconProps } from '@/components/elements/Icon';
import clsx from 'clsx';

export type StrategyDefaultProps = IconProps;

/**
 * @component ChartLine
 */
function StrategyDefault({ className, ...rest }: StrategyDefaultProps) {
  return (
    <Icon
      viewBox="0 0 25 51"
      className={clsx(`fill-gray-800`, className)}
      {...rest}
    >
      <path d="M0 50.4024C0.87967 48.46 1.88913 46.5791 3.02154 44.7724C4.86279 42.0184 6.90076 39.5516 6.90076 39.5516C3.97758 36.1838 5.07917 30.4594 7.2391 26.0412C8.49414 23.476 9.18659 20.6512 9.76886 17.5156C10.1623 15.3517 10.3865 12.2869 7.82532 11.0791C8.15116 10.7393 8.52816 10.4525 8.94266 10.2293C6.77093 8.34868 6.12964 5.78746 6.77093 3.75736C7.11485 2.67607 7.79147 1.731 8.70427 1.057C9.61707 0.383001 10.7194 0.0144877 11.854 0.00404342C12.9667 -0.0396649 14.0644 0.271911 14.9882 0.893654C15.9119 1.5154 16.6138 2.41504 16.9922 3.46229C17.8381 5.58288 17.2558 8.15983 14.8244 10.1939C15.2531 10.3991 15.6504 10.664 16.0047 10.9807C14.1084 12.5741 13.9864 13.896 14.2422 16.3471C14.4349 18.1766 15.7883 23.7868 16.7326 26.0373C18.2276 29.6017 20.1869 36.1327 16.9765 39.5476C16.9765 39.5476 20.0177 42.8564 20.9108 44.2688C22.1914 46.2301 23.3313 48.2797 24.3218 50.4024H0Z" />
    </Icon>
  );
}

export default StrategyDefault;
